import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  checkAll() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = true
    })
  }

  uncheckAll() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = false
    })
  }
}
